import { ReactElement } from 'react'
import cn from 'classnames'
import { ToastType, useUI } from '@corratech/pylot-ui/context'
import { Cross, Error, Success, Warning } from '@components/icons'
import s from './CartToast.module.scss'

const CartToast = (): ReactElement | null => {
    const { closeCartToast, cartToastText, displayCartToast, cartToastType } =
        useUI()

    if (!displayCartToast) {
        return null
    }

    return (
        <div
            className={cn(s['toast-container'], 'toast-container', {
                'bg-alert-danger-toast': cartToastType === ToastType.Danger,
                'bg-alert-warning-toast': cartToastType === ToastType.Warning,
                'bg-alert-success-toast': cartToastType === ToastType.Success
            })}
        >
            <div className={cn(s['toast-content'], 'toast-content')}>
                <div
                    className={cn(
                        s['toast-content-inner'],
                        'toast-content-inner'
                    )}
                >
                    {cartToastType === ToastType.Success && <Success />}
                    {cartToastType === ToastType.Danger && <Error />}
                    {cartToastType === ToastType.Warning && <Warning />}
                    <div className={cn(s['toast-text'], 'toast-text')}>
                        {cartToastText}
                    </div>
                </div>
                <Cross
                    className={cn(s['close-icon'], 'close-icon')}
                    onClick={closeCartToast}
                />
            </div>
        </div>
    )
}

export default CartToast
